import { Field } from '@app/shared/generic-data/generic-data';

export interface AgGridDataRow extends Record<string, any> {
  fields: Field[];
}

export const mapFieldsToRow = (row: AgGridDataRow) => {
  type AccumulatorType = { [key: string]: any };
  return row.fields.reduce<AccumulatorType>((acc, { name, value }) => {
    acc[name] = value;
    return acc;
  }, {});
};

export const mapAllFieldsToRows = (fields: AgGridDataRow[]) =>
  fields ? fields.map((row) => mapFieldsToRow(row)) : [];
